import { ObjectValues } from 'types';

export const TABLE_EXPORT_ROWS = {
  ALL: 'all',
  PAGE: 'page',
} as const;

export type TableExportRows = ObjectValues<typeof TABLE_EXPORT_ROWS>;

export const TABLE_EXPORT_COLUMNS_SCOPE = {
  VISIBLE: 'visible',
  ALL: 'all',
} as const;

export type TableExportColumnsScope = ObjectValues<
  typeof TABLE_EXPORT_COLUMNS_SCOPE
>;

export const TABLE_EXPORT_FORMAT = {
  CSV: 'csv',
  XLSX: 'xlsx',
} as const;

export type TableExportFormat = ObjectValues<typeof TABLE_EXPORT_FORMAT>;

export type TableExportSelection = {
  rows: TableExportRows;
  columns: TableExportColumnsScope;
  format: TableExportFormat;
};

export type TableExportParams = {
  format: TableExportFormat;
  columns?: string[];
  uniqueId?: string;
};
